module.exports = __webpack_public_path__ + "static/media/lasagna.58e0f222.jpg";